import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { LocalStorageService } from '@shared/service';
import { WindowService } from '@shared/window';
import { CategoryModel } from '../../models/category.model';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizePipe } from '../../../../../i18n/pipes/lozalize.pipe';

@Component({
    selector: 'app-category-thumbnail',
    templateUrl: './category-thumbnail.component.html',
    styleUrls: ['./category-thumbnail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, TranslatePipe, LocalizePipe],
})
export class CategoryThumbnailComponent {
    private windowService = inject(WindowService);
    private localStorageService = inject(LocalStorageService);

    @Input({ required: true }) category!: CategoryModel;
    @Input() last?: boolean;

    @Input() isBigAmountOfCategories = false;

    onCategoryClick(slug: string): void {
        this.localStorageService.setItem('slug', slug);
    }

    get isBrowser(): boolean {
        return this.windowService.isBrowser;
    }
}
